

<template>
  <div class="x-article">
    <div class="container-width">
      <div class="title">
        {{ current.title }}
      </div>
      <ul class="post-meta" v-if="showorigin">
        <li>发布时间：{{ current.releaseDate }}</li>
        <li>点击次数：{{ current.views }}</li>
        <li v-if="DWIDTH">来源：{{ current.origin }}</li>
      </ul>
      <ul class="post-meta" v-if="showorigin && DWIDTH == false">
        <li>来源：{{ current.origin }}</li>
      </ul>
      <div class="content" v-html="current.description"></div>
      <!-- 联系我们 -->
      <div class="e-mail" v-if="page == 'dean'">
        <a href="mailto:shengjing@sj-hospital.org">给院长发送电子邮件</a>
      </div>
      <!-- zbcpgg 招标产品公告 -->
      <div class="" v-if="page == 'zbcpgg'">
        <div class="gg_mian">
          <div class="gg_tit">
            <span>招标项目名称</span>
          </div>
          <div class="gg_text">
            <p>{{ current.projectName }}</p>
          </div>
        </div>
        <div class="gg_mian">
          <div class="gg_tit">
            <span>论证产品要求和说明</span>
          </div>
          <div class="gg_text">
            <p v-html="current.productExplain"></p>
          </div>
        </div>
        <div class="gg_mian">
          <div class="gg_tit">
            <span>发布时间</span>
          </div>
          <div class="gg_text">
            <p>
              {{
                current.proReleaseDate
                  ? current.proReleaseDate.substr(0, 10)
                  : ""
              }}{{ current.releaseWord }}
            </p>
          </div>
        </div>
        <div class="gg_mian">
          <div class="gg_tit">
            <span>论证时间</span>
          </div>
          <div class="gg_text">
            <p>{{ current.proofDate }}{{ current.proofWord }}</p>
          </div>
        </div>
        <div class="gg_mian" v-if="current.files && current.files.length">
          <div class="gg_tit">
            <span>附件</span>
          </div>
          <div class="gg_text">
            <p v-for="(item, index) in current.files" :key="index">
              <a :href="item.url" target="_blank"
                >{{ item.name }}（点击可下载）</a
              >
            </p>
          </div>
        </div>
        <div class="apply">
          <a class="xiazai" @click="dialogVisible = true"
            ><i class="iconfont icon-baoming"></i>点击报名</a
          >
        </div>
      </div>
      <!-- cplzgg 产品论证公告 -->
      <div class="" v-if="page == 'cplzgg'">
        <div class="gg_mian">
          <div class="gg_tit">
            <span>论证项目名称</span>
          </div>
          <div class="gg_text">
            <p>{{ current.projectName }}</p>
          </div>
        </div>
        <div class="gg_mian">
          <div class="gg_tit"><span>论证产品要求和说明</span></div>
          <div class="gg_text">
            <p v-html="current.productExplain"></p>
          </div>
        </div>
        <div class="gg_mian">
          <div class="gg_tit"><span>发布时间</span></div>
          <div class="gg_text">
            <p>
              {{
                current.proReleaseDate
                  ? current.proReleaseDate.substr(0, 10)
                  : ""
              }}{{ current.releaseWord }}
            </p>
          </div>
        </div>
        <div class="gg_mian">
          <div class="gg_tit"><span>论证时间</span></div>
          <div class="gg_text">
            <p>{{ current.proofDate }}{{ current.proofWord }}</p>
          </div>
        </div>
        <div class="gg_mian" v-if="current.files && current.files.length">
          <div class="gg_tit"><span>附件</span></div>
          <div class="gg_text">
            <p v-for="(item, index) in current.files" :key="index">
              <a :href="item.url" target="_blank"
                >{{ item.name }}（点击可下载）</a
              >
            </p>
          </div>
        </div>
        <div class="apply">
          <a class="xiazai" @click="dialogVisible = true"
            ><i class="iconfont icon-baoming"></i>点击报名</a
          >
        </div>
      </div>

      <div v-if="showBeforeAfter" class="link-article">
        <span
          :class="before.active ? 'article_fanye active' : 'article_fanye'"
          @click="goBefore"
          :title="before.title"
          >上一篇：{{ before.title }}</span
        >
        <span
          :class="after.active ? 'article_fanye active' : 'article_fanye'"
          @click="goAfter"
          :title="after.title"
          style="text-align: right"
          >下一篇：{{ after.title }}</span
        >
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="75%"
      :append-to-body="true"
      title="参与公司报名信息"
    >
      <el-form
        label-width="140px"
        :model="applyContent"
        :rules="rules"
        ref="applyContent"
      >
        <el-form-item label="公司名称：" prop="companyName">
          <el-input v-model="applyContent.companyName"></el-input>
        </el-form-item>
        <el-form-item label="公司所在地址：" prop="companyAddress">
          <el-input v-model="applyContent.companyAddress"></el-input>
        </el-form-item>
        <el-form-item label="公司联系电话：" prop="companytel">
          <el-input v-model="applyContent.companytel"></el-input>
        </el-form-item>
        <el-form-item label="联系人：" prop="name">
          <el-input v-model="applyContent.name"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话： " prop="tel">
          <el-input v-model="applyContent.tel"></el-input>
        </el-form-item>
      </el-form>
      <div @click="submitForm('applyContent')" class="submit">提交</div>
    </el-dialog>
  </div>
</template>
    
<script>
import service from "../service/index";
export default {
  name: "ARTICLE",
  props: {
    current: {
      type: Object,
      default: function () {
        return {};
      },
    },
    before: {
      type: Object,
      default: function () {
        return {};
      },
    },
    after: {
      type: Object,
      default: function () {
        return {};
      },
    },
    // 是否显示上一篇 下一篇
    showBeforeAfter: {
      type: Boolean,
      default: false,
    },
    //是否显示来源 发布时间 点击次数
    showorigin: {
      type: Boolean,
      default: false,
    },
    //招标产品公告  产品论证公告 做页面判断用
    page: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialogVisible: false,
      applyContent: {
        name: "",
        tel: "",
        companyName: "",
        companyAddress: "",
        companytel: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        tel: [{ required: true, message: "请输入联系人电话", trigger: "blur" }],
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        companyAddress: [
          { required: true, message: "请输入公司地址", trigger: "blur" },
        ],
        companytel: [
          { required: true, message: "请输入公司联系电话", trigger: "blur" },
        ],
      },
      DWIDTH: false, // 移动端适配
    };
  },
  methods: {
    goBefore() {
      if (this.before.url) {
        window.open(this.before.url, "_blank");
      } else {
        let articleId = this.before.id;
        if (this.before.id) {
          this.$emit("changePage", articleId);
        }
      }
    },
    goAfter() {
      if (this.after.url) {
        window.open(this.after.url, "_blank");
      } else {
        let articleId = this.after.id;
        if (this.after.id) {
          this.$emit("changePage", articleId);
        }
      }
    },
    submitForm(formName) {
      let params = {
        bidId: this.$route.query.id,
        compName: this.applyContent.companyName,
        compAddr: this.applyContent.companyAddress,
        compTel: this.applyContent.companytel,
        link: this.applyContent.name,
        linkTel: this.applyContent.tel,
        signupDate: this.getNowTime(),
        zt: 0,
      };

      params.biddingsignup = this.current.title;
      params.type = this.page == "zbcpgg" ? 1 : 2;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          service.getwzBiddingNotice(params, (res) => {
            if (res.message == "保存成功") {
              this.$message({
                message: "报名成功",
                type: "success",
              });
            } else {
              this.$message({
                message: "报名失败,请联系管理员",
                type: "error",
              });
            }
            this.applyContent = {
              name: "",
              tel: "",
              companyName: "",
              companyAddress: "",
              companytel: "",
            };
            this.dialogVisible = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getNowTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let monthStr = month >= 10 ? month : "0" + month;
      let day = date.getDate();
      let dayStr = day >= 10 ? day : "0" + day;
      let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minute =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let second =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

      return (
        year +
        "-" +
        monthStr +
        "-" +
        dayStr +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
    },
  },
  mounted() {
    if (window.screen.width < 420) {
      this.DWIDTH = false;
    } else {
      this.DWIDTH = true;
    }
  },
  watch: {},
  created() {},
  destroyed() {},
};
</script>
    
<style scoped lang="scss">
.x-article {
  -webkit-transition: all 0.5s ease 0s;
  -moz-transition: all 0.5s ease 0s;
  transition: all 0.5s ease 0s;
  box-shadow: 4px 4px #ececec;
  margin-bottom: 50px;
  border: 1px solid #ebebeb;
  border-top: none;
  box-sizing: border-box;
  .container-width {
    .title {
      padding-top: 30px;
      padding-bottom: 30px;
      font-weight: bold;
      text-align: center;
      border-bottom: 1px solid #ebebeb;
      font-size: 1.8rem;
      color: #323232;
    }
    .post-meta {
      display: -webkit-flex;
      display: flex;
      -webkit-justify-content: center;
      justify-content: center;

      height: 56px;
      border-bottom: 1px solid #ebebeb;
      border-width: 1px 0;
      li {
        text-align: center;
        font-size: 1rem;
        font-weight: bold;
        height: 56px;
        line-height: 56px;
        border-right: 1px solid #ebebeb;

        color: #8d8d8d;
        font-weight: 500;
        padding-left: 20px;
        padding-right: 20px;
        i {
          font-size: 1.2rem;
          color: #8d8d8d;
          font-weight: bold;
          display: inline-block;
          margin-right: 5px;
        }
      }
      li:last-child {
        border-right: none;
      }
    }
    .content {
      font-size: 1rem;
      color: #323232;
      padding: 20px 35px;
      line-height: 40px;
      table {
        width: 90% !important;
      }
    }
    .e-mail {
      margin-top: -20px;
      margin-bottom: 40px;
      text-align: left;
      padding: 20px 35px;
      margin-left: 2rem;
      a {
        background: #00479d;
        padding: 20px 35px;
        box-sizing: border-box;
        color: #fff;
      }
    }
    .link-article {
      border: 1px solid #ebebeb;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;
      padding: 30px;
      color: #323232;
      span {
        font-size: 1.2rem;
        width: 45%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
  }
}
.box {
  margin-bottom: 30px;
  padding: 30px;
  color: #fff;
  text-align: center;
  background-color: #009bdb;

  width: 194px;
  height: 275px;
  background-size: 100% 100%;
}

.active {
  cursor: pointer;
  color: #00479d;
}
.gg_mian {
  padding: 20px 35px;
  .gg_tit {
    border-bottom: 1px solid #00479d;
    span {
      display: block;
      width: 200px;
      background: #00479d;
      color: #fff;
      height: 60px;
      text-align: center;
      line-height: 60px;
    }
  }
  .gg_text {
    margin-top: 20px;
  }
}
.apply {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;

  margin-bottom: 50px;
  .xiazai {
    cursor: pointer;
    width: 350px;
    height: 60px;
    line-height: 60px;
    color: #fff;
    background: #00479d;
    display: block;
    text-align: center;
    i {
      margin-right: 10px;
    }
  }
}
.submit {
  width: 120px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #00479d;
  color: #fff;
  margin: 0 auto;
  cursor: pointer;
}
@media only screen and (max-width: 440px) {
}
@media only screen and (max-width: 728px) {
  .x-article {
    .container-width {
      .title {
        padding: 15px;
        box-sizing: border-box;
        padding-bottom: 15px;
        font-size: 14px;
      }
      .post-meta {
        padding: 0;
        li {
          font-size: 0.8em;
          padding-left: 0px;
          padding-right: 0px;
          text-align: center;
          display: -webkit-flex;
          display: flex;
          -webkit-justify-content: center;
          justify-content: center;
          overflow: hidden;
          border-right: none;
          margin-right: 5px;
        }
      }
      .content {
        font-size: 0.8rem !important;
        padding: 25px 15px;
        line-height: 30px;
        box-sizing: border-box;
        table {
          width: 90% !important;
        }
        p {
          img {
            max-width: 90% !important;
          }
        }
      }

      .e-mail {
        text-align: center;
        a {
          padding: 15px 25px;
        }
      }
      .link-article {
        border: 1px solid #ebebeb;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        -ms-flex-pack: justify;
        justify-content: space-between;
        padding: 10px;
        color: #323232;
        span {
          font-size: 0.8rem;
          width: 45%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .gg_mian {
    padding: 0px 10px;
    font-size: 12px !important;
    .gg_tit {
      border-bottom: 1px solid #00479d;
      span {
        display: block;
        width: 150px;
        background: #00479d;
        color: #fff;
        height: 30px;
        text-align: center;
        line-height: 30px;
      }
    }
    .gg_text {
      margin-top: 20px;
      p {
        font-size: 12px !important;
      }
    }
  }

  .apply {
    margin-bottom: 20px;
    .xiazai {
      width: 90%;
      height: 40px;
      line-height: 40px;
      color: #fff;
      background: #00479d;
      display: block;
      text-align: center;
      i {
        margin-right: 10px;
      }
    }
  }
}
</style>
    
  
     